<script setup lang="ts">
import { computed } from 'vue';
import GradientSpinner from '~/components/shared/GradientSpinner.vue';

const props = defineProps<{
    isLoading: boolean;
    totalCost: number;
    yearSavings: number;
    monthlySavings: number;
}>();

const results = computed(() => [
    {
        label: 'Total cost:',
        value: `$${props.totalCost.toLocaleString()}`,
    },
    {
        label: '25 year savings:',
        value: `$${props.yearSavings.toLocaleString()}`,
    },
    {
        label: 'Monthly savings:',
        value: `$${props.monthlySavings.toLocaleString()}`,
    },
]);
</script>
<template>
    <div class="w-100 p-100 results">
        <div
            v-for="(result, index) in results"
            :key="result.label"
            class="d-flex justify-content-between align-items-center"
            :class="{ 'mb-100': index < results.length - 1 }">
            <h3
                class="text-blue-900 mb-0"
                data-testid="result-label">
                {{ result.label }}
            </h3>
            <GradientSpinner
                v-if="props.isLoading"
                class="mr-50" />
            <h3
                v-else
                class="text-blue-900 mb-0"
                data-testid="result-value">
                {{ result.value }}
            </h3>
        </div>
    </div>
</template>
<style lang="scss">
@use '@energysage/es-ds-styles/scss/variables';

.results {
    border: 1px dashed variables.$blue-100;
    background-color: #fafafa;
    h3 {
        font-size: variables.$font-size-200;
        line-height: variables.$line-height-100;
    }
}
</style>
